import * as GeoJSON from "geojson";
import { Poligono } from "../types/Poligono";
import { useEffect } from "react";
import { useMap } from "react-leaflet";

export function cleanGeometry(geo: any) {
  if (!geo || !geo.coordinates) return geo;

  if (geo.type === "Polygon") {
    return {
      ...geo,
      coordinates: [geo.coordinates[0]] // solo anillo exterior
    };
  }

  if (geo.type === "MultiPolygon") {
    return {
      ...geo,
      coordinates: geo.coordinates.map((poly: any) => [poly[0]]) // solo anillo exterior
    };
  }

  return geo;
}

export function getCentroid(geojson: any): [number, number] | null {
  if (!geojson || !geojson.coordinates) return null;

  let coords = geojson.coordinates;

  // MultiPolygon → tomar el primer polígono
  if (geojson.type === "MultiPolygon") {
    coords = coords[0];
  }

  const ring = coords[0];
  if (!ring || ring.length === 0) return null;

  let x = 0, y = 0;
  ring.forEach(([lon, lat]: [number, number]) => {
    x += lon;
    y += lat;
  });

  const lat = y / ring.length;
  const lon = x / ring.length;

  return [lat, lon]; // tuple garantizado
}

export function toFeatureCollection(poligonos: Poligono[]): GeoJSON.FeatureCollection {
  return {
    type: "FeatureCollection",
    features: poligonos
      .filter(p => p.geometry)
      .map(p => ({
        type: "Feature",
        properties: {
          id: p.id,
          codzona: p.codzona,
          nomzona: p.nomzona
        },
        geometry: JSON.parse(p.geometry)
      }))
  };
}

export function MapRefSetter({ mapRef }: { mapRef: React.MutableRefObject<L.Map | null> }) {
  const map = useMap();
  useEffect(() => {
    mapRef.current = map;
  }, [map]);
  return null;
}
